// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sidebar {
    width: 18.125rem;
    background-color: var(--white);
    border-right: solid 1px #F4F7FE;
    display: flex;
    flex-direction: column;
    height: 100vh;
}

#sidebar>* {
    padding-left: 2.25rem;
}

#sidebar>div {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #F4F7FE;
}

#sidebar nav {
    flex: 1 1;
    overflow: auto;
    padding-top: 2.562rem;
    width: 100%;
}


#sidebar nav a.active span {
    color: inherit;
}

i {
    color: #818181;
}

#sidebar nav .active i {
    color: inherit;
}

#sidebar ul {
    padding: 0;
    margin: 0;
    list-style: none;
    width: 100%;
}

#sidebar li {
    margin: 0.25rem 0;
    width: 100%;
}

#sidebar nav a {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
    white-space: pre;
    border-radius: 8px;
    text-decoration: none;
    width: 100%;
    margin-bottom: 24px;
    padding: 10px 0px 10px 10px;
}

#sidebar nav a .active-bar {
    width: 4px;
    height: 36px;
    align-self: flex-end;
    margin-left: auto;
    border-radius: 25px;
}

#sidebar nav a .active-bar.active {
    background-color: var(--purple);
}

#sidebar nav a:hover {
    background: var(--field-background);
}

nav>ul>li {
}

nav>ul>li img {
    width: 18px;
    height: 18px;
    margin-right: 16px;
    mix-blend-mode: multiply;
}

nav .active {
    color: var(--light-black);
    font-family: var(--Inter-Bold700);
}

nav .inactive {
    color: var(--placeholder-grey);
    font-family: var(--inter-Medium500);
}
.main {
    overflow-x: scroll;
    scrollbar-width: none; /* Firefox */
}

.scrollable-x::-webkit-scrollbar {
    display: none; /* Hide scrollbar for WebKit browsers */
}
#second-container-wrap .main {
    box-sizing: border-box;
    max-width: 100%;
    overflow-x: scroll;
    overflow-y: auto;
    scrollbar-color: #888 #f0f0f0;
    scrollbar-width: thin;
    white-space: nowrap;
    z-index: 9;
}

/* For Webkit browsers (Chrome, Edge, Safari) */
#second-container-wrap .main::-webkit-scrollbar {
    height: 8px; /* Adjust the scrollbar height */
}

#second-container-wrap .main::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}

#second-container-wrap .main::-webkit-scrollbar-track {
    background: #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/components/sidebar/SideBar.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,SAAO;IACP,cAAc;IACd,qBAAqB;IACrB,WAAW;AACf;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;AACA;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,8BAA8B;IAC9B,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,qBAAqB,EAAE,YAAY;AACvC;;AAEA;IACI,aAAa,EAAE,uCAAuC;AAC1D;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,qBAAqB;IACrB,mBAAmB;IACnB,UAAU;AACd;;AAEA,+CAA+C;AAC/C;IACI,WAAW,EAAE,gCAAgC;AACjD;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["#sidebar {\n    width: 18.125rem;\n    background-color: var(--white);\n    border-right: solid 1px #F4F7FE;\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n}\n\n#sidebar>* {\n    padding-left: 2.25rem;\n}\n\n#sidebar>div {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n    border-bottom: 1px solid #F4F7FE;\n}\n\n#sidebar nav {\n    flex: 1;\n    overflow: auto;\n    padding-top: 2.562rem;\n    width: 100%;\n}\n\n\n#sidebar nav a.active span {\n    color: inherit;\n}\n\ni {\n    color: #818181;\n}\n\n#sidebar nav .active i {\n    color: inherit;\n}\n\n#sidebar ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    width: 100%;\n}\n\n#sidebar li {\n    margin: 0.25rem 0;\n    width: 100%;\n}\n\n#sidebar nav a {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    overflow: hidden;\n    white-space: pre;\n    border-radius: 8px;\n    text-decoration: none;\n    width: 100%;\n    margin-bottom: 24px;\n    padding: 10px 0px 10px 10px;\n}\n\n#sidebar nav a .active-bar {\n    width: 4px;\n    height: 36px;\n    align-self: flex-end;\n    margin-left: auto;\n    border-radius: 25px;\n}\n\n#sidebar nav a .active-bar.active {\n    background-color: var(--purple);\n}\n\n#sidebar nav a:hover {\n    background: var(--field-background);\n}\n\nnav>ul>li {\n}\n\nnav>ul>li img {\n    width: 18px;\n    height: 18px;\n    margin-right: 16px;\n    mix-blend-mode: multiply;\n}\n\nnav .active {\n    color: var(--light-black);\n    font-family: var(--Inter-Bold700);\n}\n\nnav .inactive {\n    color: var(--placeholder-grey);\n    font-family: var(--inter-Medium500);\n}\n.main {\n    overflow-x: scroll;\n    scrollbar-width: none; /* Firefox */\n}\n\n.scrollable-x::-webkit-scrollbar {\n    display: none; /* Hide scrollbar for WebKit browsers */\n}\n#second-container-wrap .main {\n    box-sizing: border-box;\n    max-width: 100%;\n    overflow-x: scroll;\n    overflow-y: auto;\n    scrollbar-color: #888 #f0f0f0;\n    scrollbar-width: thin;\n    white-space: nowrap;\n    z-index: 9;\n}\n\n/* For Webkit browsers (Chrome, Edge, Safari) */\n#second-container-wrap .main::-webkit-scrollbar {\n    height: 8px; /* Adjust the scrollbar height */\n}\n\n#second-container-wrap .main::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 4px;\n}\n\n#second-container-wrap .main::-webkit-scrollbar-track {\n    background: #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
